import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { linkToObject } from 'src/app/stores/utils';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  isShow: boolean = false;
  constructor(private readonly router: Router) {
    const link = linkToObject(this.router.url);
    this.isShow = Object.keys(link).length === 0;
  }
}
